import { RESPONSE_SUCCESS } from '@constants'
import { batchOrderNew } from './pool'
import cloneDeep from 'lodash/cloneDeep'

export default {
  data() {
    return {
      COM_HTTP: {},
      fromType: 'editRouter',
      rowData: {},
      keyBtn: false,
      multipleSelection: [],
      tabActive: 0,
      formCustomerOrderId: null,
      failList: [],
      successList: [],
      showBulkResult: false,
      showImportResult: false,
      originList: [],
      rowResult: {},
      rowSuccess: {}
    }
  },
  methods: {
    updateSingleOrder (formData, type) {
      const list = cloneDeep(this.successList)
      const index = this.failList.findIndex(item => item.id === formData.id)
      if (index > -1) {
        this.failList.splice(index, 1)
      }
      const currentIndex = list.findIndex(i => i.id === formData.id)
      if (currentIndex < 0) {
        list.unshift(formData)
      } else {
        this.$set(list, currentIndex, formData)
      }
      if (type === 2) {
        this.$refs.editForm.closeDialog()
      } else {
        this.$refs.editOrder.close()
      }
      this.successList = cloneDeep(list)
    },
    selectChange(data, current, flag) {
      if (flag === 1) {
        this.handleSelectAll(data)
      } else {
        this.handleSelectionChange(data, current)
      }
    },
    handleSelectAll (val) {
      if (val.length > 0) {
        this.multipleSelection = this.originList
      } else {
        this.isSelectAll = false
        this.multipleSelection = []
      }
      this.isSinleSelection = []
    },
    handleSelectionChange (val, currentRow) {
      const isChecked = val.some((item) => item.id === currentRow.id)
      if (this.isSelectAll) {
        if (!isChecked) {
          this.isSinleSelection = [...(this.isSinleSelection || []), currentRow.id]
        } else {
          this.isSinleSelection = this.isSinleSelection.filter((item) => item !== currentRow.id)
        }
        this.multipleSelection = this.originList.filter((item) => !this.isSinleSelection.includes(item.id))
      } else {
        this.multipleSelection = val
      }
      console.log('this.multipleSelection', this.multipleSelection)
    },
    async setOrder () {
      this.keyBtn = true
      if (this.multipleSelection.length === 0) return this.$message.warning(this.$lang('请选择要下单的订单'))
      if (this.containSender) {
        this.multipleSelection.forEach((item, index) => {
          item.packageChargeWeight = item.packageTotalWeight
          item.paymentModeCode = 'PP_PM'
          item.paymentModeName = this.$lang('Monthly')
          item.needDispatch = this.$store.state.base.user.scheduleType
          item.isUnpackEnabled = item.isUnpackEnabled ? 1 : 0
        })
      }
      this.submitParams = {
        orders: this.multipleSelection,
      }
      this.bulkOrder()
    },
    async bulkOrder () {
      this.keyBtn = true
      this.showImportResult = false
      this.showBulkResult = false
      this.bulkOrdering = true
      this.progress = 0
      const timer1 = setInterval(() => {
        this.progress++
        if (this.progress >= 98) {
          clearInterval(timer1)
        }
      }, 20)
      const result = await batchOrderNew.sendOrder(this.submitParams)
      clearInterval(timer1)
      const timer2 = setInterval(() => {
        this.progress++
        if (this.progress >= 100) {
          clearInterval(timer2)
          submitSuccess()
        }
      }, 20)
      const $this = this
      const submitSuccess = function () {
        const { code, msg, data } = result
        if (code === RESPONSE_SUCCESS) {
          $this.bulkOrdering = false
          $this.allLength = $this.submitParams.orders.length
          $this.errorLength = data.length
          $this.successLength = $this.allLength - $this.errorLength
          $this.showBulkResult = true
          if (data.length === 0) {
            $this.$message.success($this.$lang('下单成功'))
            $this.deleteOrder()
          } else if (data.length > 0) {
            const formIndexArray = $this.multipleSelection.map(i => i.id)
            const originArray = []
            $this.originList.forEach((originListItem) => {
              if (formIndexArray.indexOf(originListItem.id) < 0) {
                originArray.push(originListItem)
              }
            })
            originArray.sort((a, b) => {
              return a.id - b.id
            })

            $this.multipleSelection = []
            if ($this.tabActive === 0) {
              $this.successList = originArray
            } else if ($this.tabActive === 1) {
              $this.failList = originArray
            }
            $this.originList = originArray
            $this.isSelectAll = false
          }
        } else {
          $this.bulkOrdering = false
          $this.$message.error(msg)
        }
        $this.keyBtn = false
      }
    },
    editClose () {
      this.keyBtn = false
    },
    checkOrderClose () {
      this.checkOrderVisible = false
    },
    editHandle (row, type) {
      const newRow = cloneDeep(row)
      newRow.codMoney = row.codMoney ? row.codMoney.toString() : ''
      if (row.expressTypeName && row.expressTypeCode) {
        newRow.expressType = {
          label: row.expressTypeName,
          value: row.expressTypeCode
        }
      }
      if (row.goodsTypeName && row.goodsTypeCode && row.goodsTypeId) {
        newRow.goodsType = {
          name: row.goodsTypeName,
          code: row.goodsTypeCode,
          id: row.goodsTypeId
        }
      }
      this.rowResult = Object.assign({}, { ...newRow })
      this.$refs.editForm.openEditSuccess(type)
    },
    editHandleSuccess(row) {
      const resultRow = cloneDeep(row)
      resultRow.codMoney = row.codMoney ? row.codMoney.toString() : ''
      if (row.expressTypeName && row.expressTypeCode) {
        resultRow.expressType = {
          label: row.expressTypeName,
          value: row.expressTypeCode
        }
      }
      if (row.goodsTypeName && row.goodsTypeCode && row.goodsTypeId) {
        resultRow.goodsType = {
          name: row.goodsTypeName,
          code: row.goodsTypeCode,
          id: row.goodsTypeId
        }
      }
      this.rowSuccess = Object.assign({}, { ...resultRow })
      this.$refs.editOrder.openSuc()
    },
    deleteOrder () {
      const formIndexArray = []
      const originArray = []
      this.multipleSelection.forEach((item) => {
        formIndexArray.push(item.id)
      })
      this.originList.forEach((originListItem) => {
        if (formIndexArray.indexOf(originListItem.id) < 0) {
          originArray.push(originListItem)
        }
      })
      this.multipleSelection = []
      if (this.tabActive === 0) {
        this.successList = originArray
      } else if (this.tabActive === 1) {
        this.failList = originArray
      }
      this.originList = originArray
      this.isSelectAll = false
    }
  }
}
